import BaseAPI from "../api";

const path: string = "/my_online_course_shopping_cart";

export class MyOnlineCourseShoppingCartApi extends BaseAPI {
  static list(): Promise<any> {
    return this.api.get(`${path}`);
  }
   static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
   static delete(): Promise<any> {
    return this.api.delete(`${path}`);
  }
   static deleteById(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}` );
  }
}